(() => {
  const SELECTOR = '.top-mv-swiper__swiper.swiper';

  function waitForSwiper(tries = 60) {
    return new Promise((resolve, reject) => {
      const tick = () => {
        if (window.Swiper) return resolve();
        if (tries-- <= 0) return reject(new Error('Swiper not loaded'));
        setTimeout(tick, 50);
      };
      tick();
    });
  }

  function buildConfig(root) {
    const autoplayEnabled = root.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(root.dataset.autoplayDelay || '3500', 10);
    const loopEnabled = root.dataset.loop === 'true';
    const speed = parseInt(root.dataset.speed || '450', 10);

    // --- Center mode設定（ここが要望対応）---
    // 1枚/3枚 + 左右が少し見切れる：slidesPerView を小数にするのが安定
    // （pxで厳密に見切れ量を合わせたい場合は後述のslidesOffsetBefore/Afterにします）
    const config = {
      speed,
      loop: loopEnabled,
      watchOverflow: false,

      centeredSlides: true,
      // “左にも表示”したいので centeredSlidesBounds は false のまま
      centeredSlidesBounds: false,

      // 触った後も自動再生を続けたい
      autoplay: autoplayEnabled
        ? { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,

      pagination: root.querySelector('.swiper-pagination')
        ? { el: root.querySelector('.swiper-pagination'), clickable: true }
        : undefined,

      navigation:
        root.querySelector('.swiper-button-prev') && root.querySelector('.swiper-button-next')
          ? {
              prevEl: root.querySelector('.swiper-button-prev'),
              nextEl: root.querySelector('.swiper-button-next'),
            }
          : undefined,

      // SP: 1枚 + 左右見切れ（小数で“見切れ”を作る）
      slidesPerView: 1.12,
      spaceBetween: 16,

      breakpoints: {
        789: {
          // PC: 3枚 + 左右見切れ
          slidesPerView: 3.12,
          spaceBetween: 20,
        },
      },

      on: {
        init(sw) {
          // init直後に確実に start
          if (autoplayEnabled && sw.autoplay) sw.autoplay.start();
        },
        // テーマエディタやタブ復帰で止まることがあるので復活させる
        visibilityChange(sw) {
          if (autoplayEnabled && sw.autoplay && document.visibilityState === 'visible') {
            sw.autoplay.start();
          }
        },
      },
    };

    return config;
  }

  async function initSwiper(root) {
    if (!root) return;

    // 既にあれば破棄して作り直す（テーマエディタの再描画対策）
    if (root._topMvSwiper && typeof root._topMvSwiper.destroy === 'function') {
      root._topMvSwiper.destroy(true, true);
      root._topMvSwiper = null;
      root.dataset.swiperInitialized = 'false';
    }

    await waitForSwiper();

    const sw = new Swiper(root, buildConfig(root));
    root._topMvSwiper = sw;
    root.dataset.swiperInitialized = 'true';
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach((el) => {
      initSwiper(el).catch((e) => console.warn(e));
    });
  }

  document.addEventListener('DOMContentLoaded', () => initAll());

  // Shopify theme editor: これらも拾うと安定します
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:select', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => initAll(e.target));
})();



